// Client Portal Tour
// The branded client login: courses, community, documents and invoices
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_memberships); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const clientPortalTour = {
  id: 'client-portal',
  name: 'Client Portal Tour',
  displayName: 'Give Clients One Front Door',
  description: 'The branded client login: courses, community, documents and invoices',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_memberships',
      popover: {
        title: "🚪 Welcome to the Client Portal",
        description: `
          The portal is your customers' front door — one branded login where their courses, community, documents, and invoices all live.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔐 How Clients Get In",
        description: `
          Customers sign in with their email and receive access based on what they have bought or been granted. No separate account admin for you to maintain by hand.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📚 What They See",
        description: `
          Whatever you enable: their **courses** and progress, the **community**, **documents** to sign, and **invoices** to pay. One place instead of hunting through old emails.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎨 Make It Yours",
        description: `
          Brand the portal with your logo and colours, and put it on your own domain. It should feel like your product, not a third-party tool.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📱 In Their Pocket",
        description: `
          On the right plan the portal is also a **branded mobile app**, so your business sits on the customer's home screen.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 One Door, Everything Behind It",
        description: `
          You can now:

✅ Give clients a single branded login
✅ Surface courses, community, documents and invoices
✅ Brand it on your own domain

**Next:** log in as a test client and check the experience end to end.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
